import nextDynamic from 'next/dynamic';
import { Navigate } from 'react-router-dom';
import { PACKS_COLLECTION_LIVE } from '@/config/features';

const Content = nextDynamic(() => import('./collection-content'), { ssr: false });

export default function Page() {
  // Not live yet — see PACKS_COLLECTION_LIVE. <Navigate> keeps the memory
  // router in charge (the next/navigation shim's redirect() would
  // window.location.assign and unload the SPA under the CDN subpath).
  if (!PACKS_COLLECTION_LIVE) return <Navigate to="/" replace />;
  return <Content />;
}
